// extracted by mini-css-extract-plugin
module.exports = {"v-application":"Footer_v-application_3KWv0","text-h1":"Footer_text-h1_uHsy-","text-h2":"Footer_text-h2_lY8CY","footer":"Footer_footer_2Crz-","cols":"Footer_cols_2B-3q"};